import React from 'react';
import { isEqual } from 'lodash';

import utils from './../../utils/utilities';

import LoadingSpinner from './../LoadingSpinner/LoadingSpinner.index.jsx';
import CustomTableBody from './../CustomTableBody/CustomTableBody.index.jsx';
import CustomTableBodyPostParamsWrapper from './../CustomTableBody/CustomTableBodyPostParamsWrapper';

class InfiniteScrollTable extends React.Component {

    /**
     * Initial component settings and validation.
     *
     * @constructor
     * @param  {Object} props   The properties passed to the component.
     */
    constructor(props) {
        super(props);
        this.state = {isLoading: true};

        this.checkColumnWidths.apply(this);

        this.showSpinner = this.showSpinner.bind(this);
        this.hideSpinner = this.hideSpinner.bind(this, this.props.tableId);
        this.setHeaderCellsWidths = this.setHeaderCellsWidths.bind(this);
    }

    /**
     * Applies the column widths to the table header cells and adds the event handlers.
     */
    componentDidMount() {
        this.setHeaderCellsWidths();
    }

    componentDidUpdate(prevProps) {
        if (!isEqual(prevProps.columnWidths, this.props.columnWidths)) {
            this.setHeaderCellsWidths();
        }
    }

    setHeaderCellsWidths() {
        let tableHeaderCells = document.querySelectorAll('#' + this.props.tableId + ' thead th');

        for (let i = 0; i < tableHeaderCells.length; i++) {
            tableHeaderCells[i].style.width = this.props.columnWidths[i] + '%';
        }
    }

    /**
     * Checks to see whether the "columnWidths" property has an invalid value.
     */
    checkColumnWidths() {

        if (!utils.isArray(this.props.columnWidths)) {
            this.throwColumnWidthsError();
        }

        if (this.props.rowsModel.length !== this.props.columnWidths.length) {
            this.throwColumnWidthsError();
        }

        for (let i = 0; i < this.props.columnWidths.length; i++) {
            if (isNaN(parseInt(this.props.columnWidths[i], 10))) {
                this.throwColumnWidthsError();
            }
        }

    }

    /**
     * Throws the "columnWidths" error message.
     */
    throwColumnWidthsError() {
        throw new TypeError('The "columnWidths" (percentages) array needs to be set as a ' +
            'property for the InfiniteScrollTable to work properly. It must contain only numbers' +
            ' and it should have the same number of elements as columns in the table.');
    }

    /**
     * Scrolls back to the top of the page.
     */
    backToTop() {
        window.scrollTo(0, 0);
    }

    /**
     * Shows the table loading spinner.
     */
    showSpinner() {
        this.setState({isLoading: true});
    }

    /**
     * Hides the table loading spinner.
     */
    hideSpinner(tableId) {
        this.setState({isLoading: false});

    }

    /**
     * Renders the InfiniteScrollTable component.
     *
     * @return  {HTML}   The DOM elements of the component.
     */
    render() {

        // Add required properties for the CustomTableBody child
        let childrenWithProps = React.Children.map(
            this.props.children,
            (child) => {
                if (child.type === CustomTableBody || CustomTableBodyPostParamsWrapper) {
                    return React.cloneElement(child, {
                        innerTable:   this.props.innerTable,
                        tableId:      this.props.tableId,
                        showSpinner:  this.showSpinner,
                        hideSpinner:  this.hideSpinner,
                        rowsModel:    this.props.rowsModel,
                        columnWidths: this.props.columnWidths
                    });
                } else {
                    return child;
                }
            }
        );

        return (
            <div className={'infinite-scroll-table ' + (this.props.innerTable ? 'inner-table': '')}>
                <div className="infinite-scroll-table__table-wrapper"
                     id={this.props.tableId}
                     {...this.props.eventHandlers}>

                    <table>
                        {childrenWithProps}
                    </table>

                </div>
                <LoadingSpinner isVisible={this.state.isLoading} isInner="true" />
            </div>
        );

    }

}

export default InfiniteScrollTable;


// WEBPACK FOOTER //
// ./src/scripts/reusable/InfiniteScrollTable/InfiniteScrollTable.index.jsx